<template>
	<div class="flex items-center gap-3">
		<div class="animate-pulse-blue bg-snk-blue-500 h-2 w-2 rounded-full"></div>
		<div class="label pt-[3px] leading-tight">
			<slot />
		</div>
	</div>
</template>
